import type { CSSProperties } from 'react';
import { inputStyle, radioStyle } from './Survey.css';

interface RadioOptionProps {
  name: string;
  value: string;
  label: string;
  required: boolean;
}

const RadioOption = ({ name, value, label, required }: RadioOptionProps) => (
  <div>
    <label
      className={inputStyle}
      style={{
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
        flexDirection: 'var(--radio-option-flex-direction, "row")' as CSSProperties['flexDirection'],
        justifyContent: 'var(--radio-option-justify-content)',
        backgroundColor: 'var(--answer-background-color)',
        color: 'var(--answer-text-color)',
        fontFamily: 'var(--answer-text-font-family)',
      }}
    >
      <input name={name} value={value} type="radio" required={required} defaultChecked={false} className={radioStyle} />
      <span>{label}</span>
    </label>
  </div>
);

export default RadioOption;
